import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import {
    getNotification
} from "../actions/Notification.action";

const initialState:any=[];

const notificationSlice = createSlice(
    {
        name:"notification",
        initialState : initialState,
        reducers:{resetAdInsert: () => initialState},
        extraReducers: (builder: ActionReducerMapBuilder<any>) => {
            builder.addCase(getNotification.fulfilled, (state, action) => {
              return { ...state, getNotification: action.payload };
            })
          }
    }
);

const { reducer } = notificationSlice;
export const { resetAdInsert } = notificationSlice.actions;

export default reducer;
